import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import Hidden from "@material-ui/core/Hidden";
import Drawer from "@material-ui/core/Drawer";
import Typography from '@material-ui/core/Typography';
// @material-ui/icons
import Search from "@material-ui/icons/Search";
import Close from "@material-ui/icons/Close";
import Info from "@material-ui/icons/InfoOutlined";
import ArrowBack from "@material-ui/icons/ArrowBack";
// core components
import styles from "assets/jss/material-kit-react/components/headerStyle.js";
import { TextField } from "@material-ui/core";

import { Dialog, DialogContent, } from "@material-ui/core";
import Link from '@material-ui/core/Link';

import { BS_ALE, geraHorarios } from "funcs/MyFuncs";

const useStyles = makeStyles(styles);

var fecharPesquisaCont = 0;

export default function Header(props) {

  const {myBackgroundColor, context} = props;

  const classes = useStyles();
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [pesquisaOpen, setPesquisaOpen] = React.useState(false);
  const [tipoInfoExibe, setTipoInfoExibe] = React.useState(0);

  const [infoAtual, setInfoAtual] = React.useState("");
  const [infoAtualTitulo, setInfoAtualTitulo] = React.useState("");

  const [infoObrigOpen, setinfoObrigOpen] = React.useState(false);
  const [infoOpen, setInfoOpen] = React.useState(false);
  React.useEffect(() => {
    if (props.changeColorOnScroll) {
      window.addEventListener("scroll", headerColorChange);
    }
    return function cleanup() {
      if (props.changeColorOnScroll) {
        window.removeEventListener("scroll", headerColorChange);
      }
    };
  });
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const headerColorChange = () => {
    const { color, changeColorOnScroll } = props;
    const windowsScrollTop = window.pageYOffset;
    if (windowsScrollTop > changeColorOnScroll.height) {
      document.body
        .getElementsByTagName("header")[0]
        .classList.remove(classes[color]);
      document.body
        .getElementsByTagName("header")[0]
        .classList.add(classes[changeColorOnScroll.color]);
    } else {
      document.body
        .getElementsByTagName("header")[0]
        .classList.add(classes[color]);
      document.body
        .getElementsByTagName("header")[0]
        .classList.remove(classes[changeColorOnScroll.color]);
    }
  };
  const { color, rightLinks, leftLinks, brand, fixed, absolute, searchClick, searchFunc, searchValue, defaultIcon, fecharPesquisa } = props;
  const appBarClasses = classNames({
    [classes.appBar]: true,
    [classes[color]]: color,
    [classes.absolute]: absolute,
    [classes.fixed]: fixed
  });
  const brandComponent = <Button className={classes.title}>{brand}</Button>;

  // height of the TextField
  const height = 35;

  // magic number which must be set appropriately for height
  const labelOffset = -10;

  const focused = false;

  const mostraIconesDefault = (defaultIcon === false) ? false : true;

  var isOpen = false;
  if (searchValue){
    isOpen = (searchValue.length > 0);
  }

  if (fecharPesquisa > fecharPesquisaCont){
    searchClick(false);
    searchFunc("");
    setPesquisaOpen(false);
    fecharPesquisaCont = fecharPesquisa;
  }

  const renderDialogInfoObrig = (infoObrig, titInfoObrig) => {
    if (infoObrig != ''){
      return (
        <Link 
            variant="body2"
            style={{ fontSize: '16px', margin: 'auto', textDecoration: 'underline', color: '#DAA520', padding: '5px 10px', textAlign: 'center', }}
            onClick={() => {
              setInfoAtual(infoObrig);
              setInfoAtualTitulo(titInfoObrig);
            }}
            href="#">
            {titInfoObrig}
        </Link>
      );
    }
  }

  const renderDialogInfoAdic = (infoAdic, titInfoAdic) => {
    if (infoAdic != ''){
      return (
        <Link 
            variant="body2"
            style={{ fontSize: '16px', margin: 'auto', textDecoration: 'underline', color: '#DAA520', padding: '5px 10px', textAlign: 'center', }}
            onClick={() => {
              setInfoAtual(infoAdic);
              setInfoAtualTitulo(titInfoAdic);
            }}
            href="#">
            {titInfoAdic}
        </Link>
      );
    }
  }

  const renderLinks = (infoAdic, titInfoAdic, infoObrig, titInfoObrig) => {
    return (
      <div style={{display: 'flex', width: '100%', marginBottom: '18px', flexDirection: 'column' }}>
        {renderDialogInfoAdic(infoAdic, titInfoAdic)}
        {renderDialogInfoObrig(infoObrig, titInfoObrig)}
        <Link 
            variant="body2"
            style={{ fontSize: '16px', margin: 'auto', textDecoration: 'underline', color: '#DAA520', padding: '5px 10px', textAlign: 'center', }}
            target={"_blank"}
            href="https://sisecomm.com.br/fazseupedido/politica-privacidade/">
            {"Política de privacidade"}
        </Link>
      </div>
    );
  }

  const resolveBack = () => {

    if (infoAtual != ''){
      setInfoAtual('');
      setInfoAtualTitulo('');
    }else{
      setInfoOpen(false);
    }
    
  }

  const renderDialogInfo = () => {

    var msgHTML    = (tipoInfoExibe == 0) ? global.infoAdic       : global.infoObrig;
    var tituloHTML = (tipoInfoExibe == 0) ? global.infoAdicTitulo : global.infoObrigTitulo;

    var infoAdic   = (global.infoAdic)  ? global.infoAdic  : '';
    var infoObrig  = (global.infoObrig) ? global.infoObrig : '';

    if (infoAtual == ""){
      return(
        <Dialog
            open={infoOpen}
            onClose={() => {setInfoOpen(false)}}
            disableBackdropClick 
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            classes={{ container: classes.root, paper: classes.paper }}
            style={{maxWidth: '720px', margin: '0 auto 0 auto', WebkitOverflowScrolling: 'touch'}}
        >
            <AppBar className={appBarClasses} style={{display: 'flex', flexDirection: 'column', backgroundColor: "#000", marginBottom: '0px'}}>
              <div style={{height: '50px', width: '100%', display: 'flex', position: 'relative'}}>
                <text style={{fontSize: '18px', fontWeight: 'bold', color: '#fff', margin: 'auto auto auto auto'}}>{"Informações"}</text>
                <div onClick={() => {resolveBack()}} style={{fontSize: '24px', fontWeight: '400', color: '#fff', position: 'absolute', top: '0%', height: '100%', width: '50px', left: '0px'}}>
                  <div style={{display: 'flex', width: '100%', height: '100%'}}>
                    <ArrowBack style={{ margin: 'auto', }}/>
                  </div>
                </div>
              </div>                
            </AppBar>
            <DialogContent style={{width: '100%', height: '100%',}}>
                <div style={{display: 'flex', flexDirection: 'column', marginTop: '30px', marginBottom: '0px'}}>
                    <div>
                      <div style={{width: '100%', display: 'flex'}}>
                        <text style={{paddingBottom: '9px', paddingTop: '3px', margin: 'auto', fontSize: '20px', fontWeight: '410', fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif', color: '#0380fc' }}>{global.infoAdicTitulo}</text>
                      </div>
                      <img src={global.siteurl + "rests/" + global.cod_restaurante + "/imgs/rest/path.php?t=restimg"} style={{width: '80%', margin: '10px 10% 10px 10%'}}></img>
                      {renderLinks(infoAdic, global.infoAdicTitulo, infoObrig, global.infoObrigTitulo)}
                    </div>
                </div>
            </DialogContent>
        </Dialog>
      );
    }else{
      return(
        <Dialog
            open={infoOpen}
            onClose={() => {setInfoOpen(false)}}
            disableBackdropClick 
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            classes={{ container: classes.root, paper: classes.paper }}
            style={{maxWidth: '720px', margin: '0 auto 0 auto', WebkitOverflowScrolling: 'touch'}}
        >
            <AppBar className={appBarClasses} style={{display: 'flex', flexDirection: 'column', backgroundColor: "#000", marginBottom: '0px'}}>
              <div style={{height: '50px', width: '100%', display: 'flex', position: 'relative'}}>
                <text style={{fontSize: '18px', fontWeight: 'bold', color: '#fff', margin: 'auto auto auto auto'}}>{"Informações"}</text>
                <div onClick={() => {resolveBack()}} style={{fontSize: '24px', fontWeight: '400', color: '#fff', position: 'absolute', top: '0%', height: '100%', width: '50px', left: '0px'}}>
                  <div style={{display: 'flex', width: '100%', height: '100%'}}>
                    <ArrowBack style={{ margin: 'auto', }}/>
                  </div>
                </div>
              </div>                
            </AppBar>
            <DialogContent style={{width: '100%', height: '100%',}}>
                <div style={{display: 'flex', flexDirection: 'column', marginTop: '30px', marginBottom: '0px'}}>
                    <div>
                      <div style={{width: '100%', display: 'flex'}}>
                        <text style={{paddingBottom: '9px', paddingTop: '3px', margin: 'auto', fontSize: '20px', fontWeight: '410', fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif', color: '#0380fc' }}>{infoAtualTitulo}</text>
                      </div>
                      <img src={global.siteurl + "rests/" + global.cod_restaurante + "/imgs/rest/path.php?t=restimg"} style={{width: '80%', margin: '10px 10% 10px 10%'}}></img>
                      <div dangerouslySetInnerHTML={{ __html:  infoAtual}} />
                    </div>
                </div>
            </DialogContent>
        </Dialog>
      );
    }

    
  }

  const renderInfoRest = () => {

    return (
      <div onClick={() => {
        if (window.scrollY == 0){
          window.scrollTo(0, 1); 
        }
        setInfoOpen(true);}} 
        style={{fontSize: '24px', fontWeight: '400', color: '#fff', position: 'absolute', top: '0%', height: '100%', width: '50px', right: '0px'}}>
        <div style={{display: 'flex', width: '100%', height: '100%'}}>
          <Info style={{ margin: 'auto' }}/>
        </div>
      </div>
    );
    
  }

  const renderMensagemLojaFechada = (ctx) => {
    if (global.restAberto != '1'){
      return (
        <div style={{width: '100%', backgroundColor: '#777', display: 'flex', position: 'relative'}}>
          <text onClick={() => {
            BS_ALE(ctx, 'Horários', 
              <div style={{width: '100%'}}>
                  <div style={{width: '215px'}}></div>
                  {geraHorarios(global.horariosFunc)}
              </div>
            )
          }} style={{fontSize: '14px', fontWeight: '400', color: 'rgb(251,255,0)', margin: 'auto auto auto auto'}}>{global.proximaAbertura}</text>
        </div>
      );
    }
  }// 

  return (
    <AppBar className={appBarClasses} style={{display: 'flex', flexDirection: 'column'}}>
      <div style={{height: '35px', width: '100%', backgroundColor: '#777', display: 'flex', position: 'relative'}}>
        <text style={{fontSize: '18px', fontWeight: 'bold', color: '#fff', margin: 'auto auto auto auto'}}>{global.nome_rest}</text>
        {renderInfoRest()}
      </div>
      {renderMensagemLojaFechada(context)}
      <Toolbar className={classes.container} style={{backgroundColor: myBackgroundColor, display: 'flex', flexDirection: 'column'}}>
        <div style={{width: '100%'}}>
          <div style={{flexDirection: 'row', display: 'flex'}}>
            <div className={classes.flex}>
              {leftLinks !== undefined ? (
                <div smDown implementation="css">
                  {leftLinks}
                </div>
              ) : (
                brandComponent
              )}
            </div>
            <Hidden smDown implementation="css">
              {rightLinks}
            </Hidden>
            <Hidden mdUp>
              {( ( (!pesquisaOpen) && (!isOpen) ) && (mostraIconesDefault) ) ? (
                <IconButton
                color="inherit"
                aria-label="open drawer"
                onClick={() => {
                  searchClick(!pesquisaOpen);
                  setPesquisaOpen(!pesquisaOpen);
                }}
                >
                  <Search />
                </IconButton>
               ) : null}
            </Hidden>
          </div>
          <div></div>
          {( (mostraIconesDefault) && (pesquisaOpen || (isOpen)) ) ? (
            <div style={{display: 'flex', flexDirection: 'row'}}>
              <TextField value={searchValue} onChange={(e) => {
              searchFunc(e.target.value)
              }} label="Pesquisa"  variant="outlined" size="small" type="text" style={{width: '100%', marginBottom: '10px',}} />
              <IconButton
                color="inherit"
                aria-label="open drawer"
                style={{marginBottom: '10px',}} 
                onClick={() => {
                  searchClick(!pesquisaOpen);
                  searchFunc("");
                  setPesquisaOpen(!pesquisaOpen);
                }}
                >
                  <Close />
              </IconButton>

            </div>
          ) : 
          (
             null
          )}
          
        </div>
      </Toolbar>
      <Hidden mdUp implementation="js">
        <Drawer
          variant="temporary"
          anchor={"right"}
          open={mobileOpen}
          classes={{
            paper: classes.drawerPaper
          }}
          onClose={handleDrawerToggle}
        >
          <div className={classes.appResponsive}>
            {leftLinks}
            {rightLinks}
          </div>
        </Drawer>
      </Hidden>
      {renderDialogInfo()}
    </AppBar>
  );
}

Header.defaultProp = {
  color: "white"
};

Header.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "info",
    "success",
    "warning",
    "danger",
    "transparent",
    "white",
    "rose",
    "dark"
  ]),
  rightLinks: PropTypes.node,
  leftLinks: PropTypes.node,
  brand: PropTypes.string,
  fixed: PropTypes.bool,
  absolute: PropTypes.bool,
  // this will cause the sidebar to change the color from
  // props.color (see above) to changeColorOnScroll.color
  // when the window.pageYOffset is heigher or equal to
  // changeColorOnScroll.height and then when it is smaller than
  // changeColorOnScroll.height change it back to
  // props.color (see above)
  changeColorOnScroll: PropTypes.shape({
    height: PropTypes.number.isRequired,
    color: PropTypes.oneOf([
      "primary",
      "info",
      "success",
      "warning",
      "danger",
      "transparent",
      "white",
      "rose",
      "dark"
    ]).isRequired
  })
};
